module.exports = {
  infant: {
    key: 'infant',
    label: 'Infant',
  },
  toddler: {
    key: 'toddler',
    label: 'Toddler',
  },
  child: {
    key: 'child',
    label: 'Child',
  },
  teenager: {
    key: 'teenager',
    label: 'Teenager',
  },
  adult: {
    key: 'adult',
    label: 'Adult',
  },
};